import type { InMemoryCacheConfig } from '@apollo/client'
import { InMemoryCache } from '@apollo/client'

export const cacheConfig: InMemoryCacheConfig = {
  addTypename: true,
  typePolicies: {
    propertiesCp: { keyFields: ['property_id', 'id'] },
    Note: { keyFields: ['note_id'] },
    // Kratos flows are single-use; never normalize/share them by id
    KratosSettingsFlow: { keyFields: false },
    KratosLoginFlow: { keyFields: false },
    Query: {
      fields: {
        allClientCases: {
          // @ts-ignore
          merge(_, incoming = []) {
            // Return the incoming array to completely replace existing data
            // This ensures we don't get cache warnings and maintains consistency
            return incoming
          },
          // Ensure proper read function to handle both array and object formats
          read(existing: unknown) {
            // If the existing data is an object with numeric keys, convert it to an array
            if (existing && !Array.isArray(existing)) {
              return Object.values(existing)
            }
            return existing
          },
        },
      },
    },
  },
}

export default new InMemoryCache(cacheConfig)
